const langIt_consorzioeuropa_consorzioeuropa = {
  "df-section-promotions.title.flyer": "I nostri volantini",
};

export default langIt_consorzioeuropa_consorzioeuropa;
